/* ═══════════════════════════════════════════════════════════════════
 YUMMY COMBS DOG MATCH QUIZ: shared engine (data, scoring, capture, tracking)
 Every product, variant ID, price and image below was pulled live from
 petsbestlife.com Admin (ihwx1y-jh) on 2026-10-09. Treat counts per bag
 (4oz = 3, 12oz = 15, 24oz = 30) were supplied by the client 2026-09-23;
 they are not published on the store.
 THEME BUILD: section ycq-chat-quiz writes window.YCQ_LIVE before this file
 loads. Live variant IDs, prices, images and Klaviyo settings from the store
 override the values below, which stay only as a fallback.
 ═══════════════════════════════════════════════════════════════════ */
var YCQ = (function () {
 // ─── CONFIG ──────────────────────────────────────────────────────────
 var LIVE = window.YCQ_LIVE || {};
 var KV_KEY = LIVE.kvKey || "T7qN3N"; // Klaviyo public site key already on petsbestlife.com
 var KV_LIST = LIVE.kvList || ""; // Klaviyo list ID, set in the theme editor. Empty = capture off, sends nothing.
 var STORE = typeof LIVE.root === "string" ? LIVE.root : "https://petsbestlife.com";
 var TRACKING = { meta: true, ga4: true, tiktok: false };

 var CDN = "https://cdn.shopify.com/s/files/1/0730/4137/9507/files/";
 var SIZES = [
 { k: "XS", label: "Extra Small", range: "5.5 to 12 lbs", short: "5.5–12 lbs", eg: "Chihuahua, Yorkie" },
 { k: "S", label: "Small", range: "13 to 25 lbs", short: "13–25 lbs", eg: "Beagle, Frenchie" },
 { k: "M", label: "Medium", range: "26 to 50 lbs", short: "26–50 lbs", eg: "Border Collie, Corgi" },
 { k: "L", label: "Large", range: "51 to 100 lbs", short: "51–100 lbs", eg: "Lab, Golden" },
 { k: "XL", label: "Extra Large", range: "100+ lbs", short: "100+ lbs", eg: "Mastiff, Newfie" }
 ];

 // index order = SIZES order
 var P = {
 trial: {
 title: "Yummy Combs 4oz Bag Chicken", name: "4oz Trial Bag", flavor: "Chicken",
 handle: "extra-small-4oz-bag-chicken-yummy-combs-copy",
 once: [45436579446963, 45436614181043, 45436626075827, 45436630925491, 45436639084723],
 price: [9.99, 9.99, 9.99, 9.99, 9.99], count: 3,
 img: ["4oz_USA_Chkn_XS_front.jpg?v=1778535239", "4oz_USA_Chkn_SM_front.jpg?v=1778535239", "4oz_USA_Chkn_MD_front.jpg?v=1778535239", "4oz_USA_Chkn_LG_front.jpg?v=1778535239", "4oz_USA_Chkn_XL_front.jpg?v=1778535239"]
 },
 c12: {
 title: "Yummy Combs 12oz Bag Chicken", name: "12oz Bag", flavor: "Chicken",
 handle: "yummy-combs-12oz-bag-chicken",
 once: [45436446441651, 45436446474419, 45436446507187, 45436446539955, 45436446572723],
 sub: [45445323260083, 45445323292851, 45445323325619, 45445323358387, 45445323391155],
 price: [26.99, 26.99, 26.99, 26.99, 26.99], subPrice: [24.29, 24.29, 24.29, 24.29, 24.29], count: 15,
 img: ["12oz_USA_Chkn_front_XS.jpg?v=1778535534", "12oz_USA_Chkn_front_SM.jpg?v=1778535534", "12oz_USA_Chkn_front_MD_1.jpg?v=1778535534", "12oz_USA_Chkn_front_LG.jpg?v=1778535534", "12oz_USA_Chkn_front_XL.jpg?v=1778535534"]
 },
 f12: {
 title: "Yummy Combs 12oz Bag Fish & Egg", name: "12oz Bag", flavor: "Fish & Egg",
 handle: "yummy-combs-12oz-bag-fish-egg",
 once: [45436639641779, 45436662644915, 45436662677683, 45436662907059, 45436664348851],
 sub: [45445674336435, 45445674369203, 45445674401971, 45445674434739, 45445674467507],
 price: [26.99, 26.99, 26.99, 26.99, 26.99], subPrice: [24.29, 24.29, 24.29, 24.29, 24.29], count: 15,
 img: ["12oz_USA_F_E_front_XS.jpg?v=1778535784", "12oz_USA_F_E_front_SM.jpg?v=1778535784", "12oz_USA_F_E_front_MD.jpg?v=1778535784", "12oz_USA_F_E_front_LG.jpg?v=1778535784", "12oz_USA_F_E_front_XL_1.jpg?v=1778535784"]
 },
 c24: {
 title: "Yummy Combs 24oz Bag Chicken", name: "24oz Bag", flavor: "Chicken",
 handle: "yummy-comb-24oz-bag-chicken",
 once: [45436449947827, 45436496674995, 45436499132595, 45436502081715, 45436502442163],
 sub: [45445679120563, 45445679153331, 45445679186099, 45445679218867, 45445679251635],
 price: [49.98, 49.98, 49.98, 49.98, 49.98], subPrice: [44.98, 44.98, 44.98, 44.98, 44.98], count: 30,
 img: ["24oz_USA_Chkn_XS_front.jpg?v=1778536125", "24oz_USA_Chkn_SM_front.jpg?v=1778536125", "24oz_USA_Chkn_MD_front.jpg?v=1778536125", "24oz_USA_Chkn_LG_front.jpg?v=1778536125", "24oz_USA_Chkn_XL_front.jpg?v=1778536125"]
 },
 mini: {
 title: "Yummy Combs (MiniPacks) Chicken", name: "MiniPacks", flavor: "Chicken",
 handle: "yummy-combs-mini-pack-chicken",
 once: [45436518858931, 45436524789939, 45436525052083, 45436525281459, 45436525412531],
 price: [22.69, 22.69, 22.69, 22.69, 22.69], count: null,
 img: ["MiniPack_USA_Chkn_XS_front.jpg?v=1778536236", "MiniPack_USA_Chkn_SM_front.jpg?v=1778536236", "MiniPack_USA_Chkn_MD_front.jpg?v=1778536236", "MiniPack_USA_Chkn_LG_front.jpg?v=1778536235", "MiniPack_USA_Chkn_XL_front.jpg?v=1778536235"]
 },
 l15: {
 title: "Longevity15 30-Packets", name: "Longevity15", flavor: "30 daily packets",
 handle: "longevity15-30-day-supply",
 once: [45436804759731, 45436826714291, 45436827140275, 45436830122163, 45436830351539],
 sub: [45445279285427, 45445279318195, 45445279350963, 45445279383731, 45445279416499],
 price: [44.99, 49.99, 54.99, 69.99, 74.99], subPrice: [40.49, 44.99, 49.49, 62.99, 67.49], count: 30,
 // Large has no variant image on the store; the product's featured image stands in
 img: ["Longevity15_USA_Sachet_Carton_XS.webp?v=1776792398", "Longevity15_USA_Sachet_Carton_SM.webp?v=1776792398", "Longevity15_USA_Sachet_Carton_MD.webp?v=1776792398", "Longevity15_Carton_Stack.png?v=1777431058", "Longevity15_USA_Sachet_Carton_XL.webp?v=1776792398"]
 }
 };

 // ─── live store data from Liquid (per size index; null entries keep the fallback) ─
 Object.keys(LIVE.products || {}).forEach(function (k) {
 var src = LIVE.products[k], dst = P[k];
 if (!dst || !src) return;
 if (src.handle) dst.handle = src.handle;
 ["once", "sub", "price", "subPrice", "img"].forEach(function (f) {
 if (!src[f]) return;
 if (!dst[f]) { if (src[f].some(function (v) { return v != null; })) dst[f] = src[f].slice(); return; }
 src[f].forEach(function (v, i) { if (v != null) dst[f][i] = v; });
 });
 });

 var Q = {
 weight: {
 id: "weight", title: "How much does your dog weigh?",
 sub: "Each bag is sized to the mouth, so the honeycomb gets chewed, not gulped.",
 options: SIZES.map(function (s, i) { return { v: i, label: s.short, desc: s.label + " · " + s.eg }; })
 },
 age: {
 id: "age", title: "How old is your dog?",
 sub: "Yummy Combs are for adult dogs, 6 months and up.",
 options: [
 { v: "pup", label: "Under 6 months", desc: "Still a puppy" },
 { v: "adult", label: "6 months to 6 years", desc: "Adult" },
 { v: "senior", label: "7 years or older", desc: "Senior" }
 ]
 },
 protein: {
 id: "protein", title: "Does chicken agree with your dog?",
 sub: "We make two recipes: Chicken, and Fish & Egg.",
 options: [
 { v: "yes", label: "Yes, chicken is fine", desc: "Eats chicken treats happily" },
 { v: "unsure", label: "Not sure, or picky", desc: "Turns down treats sometimes" },
 { v: "no", label: "We avoid chicken", desc: "Chicken doesn't sit well" }
 ]
 },
 plan: {
 id: "plan", title: "How do you want to start?",
 sub: "One treat a day is the routine. Pick the way in that suits you.",
 options: [
 { v: "try", label: "Try a small bag first", desc: "See if they love it" },
 { v: "daily", label: "Make it a daily habit", desc: "One a day, every day", badge: "10% off" },
 { v: "go", label: "Treats on the go", desc: "Travel, walker, daycare" }
 ]
 }
 };
 var ORDER = ["weight", "age", "protein", "plan"];

 // ─── helpers ─────────────────────────────────────────────────────────
 function money(n) { return "$" + n.toFixed(2); }
 function img(key, size, w) {
 var f = P[key].img[size];
 return /^(https?:)?\/\//.test(f) ? f : CDN + f + "&width=" + (w || 600);
 }
 function variantUrl(key, size, sub) {
 var p = P[key], ids = sub && p.sub ? p.sub : p.once;
 return STORE + "/products/" + p.handle + "?variant=" + ids[size];
 }
 function priceOf(key, size, sub) { var p = P[key]; return sub && p.subPrice ? p.subPrice[size] : p.price[size]; }
 // no per-treat figure on the 3-treat trial bag: it reads expensive and the bag is a taste test, not a value buy
 function perTreat(key, size, sub) { var p = P[key]; return p.count && key !== "trial" ? money(priceOf(key, size, sub) / p.count) : null; }

 // ─── scoring (accumulator, not a decision tree) ──────────────────────
 function compute(a) {
 if (a.age === "pup") return { puppy: true };
 var s = { trial: 0, c12: 0, f12: 0, c24: 0, mini: 0 };
 var CHICKEN = ["trial", "c12", "c24", "mini"];
 if (a.protein === "yes") CHICKEN.forEach(function (k) { s[k] += 1; });
 if (a.protein === "unsure") { s.trial += 3; s.f12 += 1; }
 if (a.protein === "no") { s.f12 += 20; CHICKEN.forEach(function (k) { s[k] -= 20; }); }
 if (a.plan === "try") { s.trial += 4; s.c12 += 1; }
 if (a.plan === "daily") { s.c24 += 4; s.c12 += 3; s.f12 += 2; }
 if (a.plan === "go") { s.mini += 4; s.c12 += 1; }
 var ranked = Object.keys(s).sort(function (x, y) { return s[y] - s[x]; });
 var primary = ranked[0];
 var second = null;
 if (a.age === "senior") second = "l15";
 else if (a.protein !== "no" && s[ranked[1]] > 0) second = ranked[1];
 return {
 puppy: false, primary: primary, secondary: second, scores: s,
 size: a.weight, sub: a.plan === "daily" && !!P[primary].sub,
 reasons: reasons(primary, a)
 };
 }

 function reasons(key, a) {
 var sz = SIZES[a.weight], r = [];
 r.push("Sized for dogs " + sz.range + ", so the honeycomb fits the mouth and gets chewed, not gulped.");
 if (key === "f12" && a.protein === "no") r.push("Fish & Egg is our only recipe built on fish meal and egg instead of chicken.");
 else if (key === "f12") r.push("Fish & Egg gives a picky eater a second flavor to try.");
 else if (a.protein === "unsure" && key === "trial") r.push("Not sure they'll like it? 3 treats for " + money(P.trial.price[a.weight]) + " is the cheapest way to find out.");
 else r.push("Real chicken recipe, 44% minimum protein.");
 if (key === "c24") r.push("30 treats is one a day for a month, and Subscribe & Save ships every 30 days. About " + perTreat("c24", a.weight, true) + " a treat.");
 if (key === "c12") r.push("15 treats a bag, one a day. The 24oz is the better deal once you're hooked.");
 if (key === "trial" && a.protein !== "unsure") r.push("3 treats for " + money(P.trial.price[a.weight]) + ". If they love it, step up to the 12oz or 24oz.");
 if (key === "mini") r.push("Individually portioned packs that live in a bag, a glovebox or the dog walker's pocket.");
 if (key === "f12" && a.plan === "try") r.push("There's no trial bag in Fish & Egg yet, so the 12oz is the smallest way in.");
 if (key === "f12" && a.plan === "go") r.push("MiniPacks only come in Chicken, so the 12oz Fish & Egg bag is your match.");
 if (key === "f12" && a.plan === "daily") r.push("15 treats a bag at one a day. Subscribe & Save takes 10% off.");
 return r;
 }

 var SECONDARY_COPY = {
 l15: "For dogs 7 and up. One packet of C15:0 a day with dinner, to support cellular, liver and metabolic health.",
 c12: "The standard bag: 15 treats, Subscribe & Save available.",
 c24: "30 treats, the lowest price per treat.",
 trial: "Not sure yet? 3 treats for " + money(P.trial.price[0]) + ".",
 mini: "Portioned packs for travel and the dog walker.",
 f12: "Our second recipe, built on fish meal and egg."
 };

 // ─── tracking ────────────────────────────────────────────────────────
 function track(name, params) {
 params = params || {}; params.quiz_name = "Yummy Combs Dog Match";
 try {
 if (TRACKING.meta && typeof fbq !== "undefined") fbq("trackCustom", name, params);
 if (TRACKING.tiktok && typeof ttq !== "undefined") ttq.track(name, params);
 if (TRACKING.ga4 && typeof gtag !== "undefined") gtag("event", name, params);
 } catch (e) {}
 if (window.console) console.log("[quiz event]", name, params);
 }

 // ─── Klaviyo (v3 client subscribe). Resolves either way so results never block. ─
 function subscribe(o) {
 track("QuizEmailSubmitted", { result: o.result || "puppy_hold" });
 if (!KV_LIST) { return Promise.resolve({ preview: true }); }
 return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KV_KEY, {
 method: "POST",
 headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
 body: JSON.stringify({ data: { type: "subscription", attributes: {
 custom_source: "Quiz: Yummy Combs Dog Match",
 profile: { data: { type: "profile", attributes: {
 email: o.email, first_name: o.firstName || undefined,
 properties: o.props
 } } } },
 relationships: { list: { data: { type: "list", id: KV_LIST } } } } })
 }).catch(function (e) { console.warn("Klaviyo", e); });
 }
 function validEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e); }
 function profileProps(a, res, dogName) {
 return {
 quiz_dog_name: dogName || "", quiz_dog_size: SIZES[a.weight] ? SIZES[a.weight].label : "",
 quiz_dog_age: a.age, quiz_protein: a.protein, quiz_plan: a.plan,
 quiz_result: res && !res.puppy ? P[res.primary].title : "Puppy hold (under 6 months)",
 quiz_result_url: res && !res.puppy ? variantUrl(res.primary, res.size, res.sub) : ""
 };
 }

 return { SIZES: SIZES, P: P, Q: Q, ORDER: ORDER, SECONDARY_COPY: SECONDARY_COPY,
 money: money, img: img, variantUrl: variantUrl, priceOf: priceOf, perTreat: perTreat,
 compute: compute, track: track, subscribe: subscribe, validEmail: validEmail, profileProps: profileProps,
 preview: function () { return !KV_LIST; } };
})();
